import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';
import { useMaterialUIController, setLayout } from 'context';
import useWindowDimensions from 'hooks/useWindowDimensions';

const EmailLayout = ({ children }) => {
    const [controller, dispatch] = useMaterialUIController();
    const { width } = useWindowDimensions();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, 'dashboard');
    }, [dispatch, pathname]);

    return (
        <MDBox
            sx={({ breakpoints, transitions, functions }) => ({
                position: 'relative',
                p: width <= 600 ? 0 : 3,
                background: '#fff',
                [breakpoints.up('xl')]: {
                    marginLeft: miniSidenav ? functions.pxToRem(120) : functions.pxToRem(274),
                    transition: transitions.create(['margin-left', 'margin-right'], {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            })}
        >
            {children}
        </MDBox>
    );
};

EmailLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EmailLayout;
